import Vue from "vue";
import Service from "../Service";

const resource = "hmnBiometricEquipment/";

export default {
  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID: requestID },
    });
  },
  pagination(dtr, requestID) {
    return Service.post(resource + "pagination", dtr, {
      params: { requestID: requestID },
    });
  },
  //url de listado de los biometricos
  list() {
    return Vue.prototype.$http.defaults.baseURL + "/" + resource + "list";
  },
  //endpoint de listado
  getList() {
    return Service.post(resource + "list");
  },
  //obtener la conexion del biometrico
  isConnected(requestID) {
    return Service.post(
      resource + "isConnected",
      {},
      {
        params: { requestID: requestID },
      }
    );
  },
  // Obtener relojes disponibles (TICCategoryEquipment tipo 10 no activos en HmnBiometricEquipment)
  availableClocks(currentBieID) {
    return Service.post(
      resource + "availableClocks",
      {},
      {
        params: { currentBieID: currentBieID },
      }
    );
  },
  // Obtener áreas asignadas a un reloj
  getClockAreas(bieID) {
    return Service.post(
      resource + "clockAreas",
      {},
      {
        params: { bieID: bieID },
      }
    );
  },
  // Auto-asignación de trabajador fiscalizado según contrato/área
  autoAssignWorker(wkrID, requestID) {
    return Service.post(
      resource + "autoAssignWorker",
      {},
      {
        params: { wkrID: wkrID, requestID: requestID },
      }
    );
  },
};
